export const colorStore = [
  { name: 'Белый', value: 'Белый' },
  { name: 'Желтый', value: 'Желтый' },
  { name: 'Комбинированный', value: 'комбинированный' },
  { name: 'Красный', value: 'Красный' },
];
